import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Warning: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M27 16a11 11 0 1 0-22 0 11 11 0 0 0 22 0Zm-11 4a1 1 0 1 1 0 2 1 1 0 1 1 0-2Zm-1-3v-5a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0Zm14-1a13 13 0 1 1-26 0 13 13 0 0 1 26 0Z"
    />
  </Icon>
);
